module.exports = __webpack_public_path__ + "img/1440.00bb4bda.svg";